/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, ElementRef, EventEmitter, Input, Output, Renderer2, ViewEncapsulation } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {EnvironmentService} from "@irian-ro/util-environment";
import { map, retry, switchMap, tap } from "rxjs/operators";
import { Observable, of, throwError } from "rxjs";
import { ExceptionService } from "@irian-ro/exception-service-module";

@Component({
  selector: 'well-save-as-pdf',
  templateUrl: './save-as-pdf.component.html',
  styleUrls: ['./save-as-pdf.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class SaveAsPdfComponent  {
  @Input() fileName: string | undefined = undefined;
  @Output() countNrOfPages = new EventEmitter<number>();
  private file: Blob | undefined = undefined;
  private htmlToPdfUrl: string | undefined = undefined;

  constructor(private elemRef: ElementRef,
              private http: HttpClient,
              private environmentService: EnvironmentService,
              private renderer: Renderer2,
              private exceptionService: ExceptionService) {
    this.htmlToPdfUrl = environmentService.getEnvironmentProperty('htmlToPdfUrl');
    // this.renderer.setStyle(
    //   this.elemRef.nativeElement,
    //   'font-size',
    //   '12px'
    // );
    // this.renderer.setStyle(
    //   this.elemRef.nativeElement,
    //   'color',
    //   '#1e1e1e'
    // );
  }

  public download(): void {
    this.getBlob()?.subscribe((blob) => {
      this.createDownloadLink(blob);
    });
  }

  public getBlob(): Observable<Blob> | null {
    // if (this.file) {
    //   return of(this.file);
    // } else {
      const shadowRoot = this.elemRef.nativeElement.shadowRoot;
      const html = shadowRoot.innerHTML;
      const headers = new HttpHeaders({
        'Content-Type': 'text/html',
        'Access-Control-Allow-Origin': '*'
      });

      if (html) {
        return this.http.post(this.htmlToPdfUrl, html, {
          headers,
          responseType: 'blob',
          observe: 'response'
        }).pipe(
          map(res => {
            return res.body;
          }),
          switchMap(res => {
            if (res.size === 0) {
              return throwError('Error!');
            }
            return of(res);
          }),
          retry(2),
          tap(file => {
            const exception = {
              message: JSON.stringify({
                size : file.size,
                html: html
              })
            };

            this.exceptionService.saveException(exception).subscribe();
            this.file = file;
          })
        );
      }
      return null;
    // }
  }

  createDownloadLink(file: Blob) {
    const link = document.createElement('a');
    link.href = window.URL?.createObjectURL(file);
    link.download = this.fileName;
    link.click();
  }

}
